import {
  Box,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Link,
  List,
  ListItem,
  Text,
  Heading,
  Divider,
} from "@chakra-ui/react";

export default function NominatedRepresentativeDropdown() {
  const redirectLink =
    process.env.REACT_APP_BUSINESS_ACCOUNT_NOMINATED_REPRESENTATIVE_LINK;

  return (
    <Box width="400px">
      <Accordion
        m={"15px"}
        allowToggle
        boxShadow="md"
        borderWidth="1px"
        borderRadius="md"
        bg="gray.100"
      >
        <AccordionItem>
          <AccordionButton>
            <Box flex="1" textAlign="left">
              <Heading fontSize={"1em"} fontWeight="medium" color={"red.500"}>
                Are you adding business, trust or superfund accounts?
              </Heading>
            </Box>
            <AccordionIcon color="red.500" boxSize="1.5em" />
          </AccordionButton>
          <AccordionPanel pb={4} pt={2} textAlign="left">
            <Divider mb={3} />
            <Text>
              You must be set up within your Bank's Online Banking as either a:
            </Text>
            <List styleType="disc" ml={10}>
              <ListItem>'Nominated Representative'</ListItem>
              <ListItem>'Designated Person'</ListItem>
            </List>
            <Text mt={2}>
              For more details, please visit our FAQ's
              <Link
                color={"blue.500"}
                href={
                  !!redirectLink
                    ? redirectLink
                    : "https://help.acsiss.com.au/mydata/connect-your-business-bank-account"
                }
                isExternal
                ml={1}
              >
                here
              </Link>
              .
            </Text>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </Box>
  );
}
